export default "__VITE_ASSET__BQn7WPjk__"